import $ from "jquery"

/**
 * Scripts for stat section and portfolio section padding left
 */

function calculatePadding(){
    var statsDistanceBase = $('.js-padding-base');
    var statsDistance;

    if(statsDistanceBase.length){
        var statsDistance = $(window).width() - (statsDistanceBase.offset().left + statsDistanceBase.outerWidth());
    }

    $('.js-stats-inner').css('margin-left', statsDistance + 'px');
    $('.js-brands-inner').css('margin-left', statsDistance + 'px');
    $('.js-solution-inner').css('margin-left', statsDistance + 'px');
    $('.js-next-click').css('width', statsDistance + 'px');
    $('.js-outsourcing-hero').css('margin-left', statsDistance + 'px');
    $('.js-hero-footer').css('padding-left', statsDistance + 'px');
    $('.section--brands .slick-list').css('padding-right', statsDistance + 'px');
    $('.js-solution-inner .slick-list').css('padding-right', statsDistance + 'px');
}

calculatePadding();

$(window).on('resize', function(){
    calculatePadding();
});